import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgMessagingIconFilled = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 18 18"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#fff"
            d="M0 4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v6.205a4 4 0 0 1-4 4H5.748a.68.68 0 0 0-.382.118l-3.8 2.604A1 1 0 0 1 0 16.103z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgMessagingIconFilled)
const Memo = memo(ForwardRef)
export default Memo
